import {Component, OnInit, Input} from '@angular/core';
import {DomSanitizationService} from '@angular/platform-browser';

declare var $: any;
import {DocumentoService} from './documento.service';
import {ProvinciaService} from '../provincia/provincia.service';
import {PermisoService} from '../permiso/permiso.service';
import {NotificacionService} from '../notificacion/notificacion.service';
import {LoginService} from '../login/login.service';
import {Documento} from './documento';
import {Provincia} from '../provincia/provincia';
import {RecargaCreditoService} from '../recargaCredito/recargaCredito.service';
import {ActivatedRoute, Router} from '@angular/router';

import {RecargaCreditoComponent} from '../recargaCredito/recargaCredito.component';
import 'rxjs/Rx';

import myGlobals = require('../config');
import {Sucursal} from "../sucursal/sucursal";
import {SucursalService} from "../sucursal/sucursal.service";

var moment = require('moment');

@Component({
    selector: 'documento',
    template: require('../../app/documento/documento.component.html'),
    styles: [require('../../app/documento/documento.component.css')],
    directives: [RecargaCreditoComponent],
})
export class DocumentoComponent implements OnInit {

    documento: Documento;
    documentos: Documento[];
    idSeleccionado;
    active: any;
    active2: any;
    deshabilitar: boolean;
    permisos: any;
    urlLogo: any;
    filesToUpload: any;
    usuario: any;
    sucursales: Sucursal[];
    sucursal_id: string;
    offsetTimeZone: string;

    constructor(private documentoService: DocumentoService,
                private route: ActivatedRoute,
                private loginService: LoginService,
                private permisoService: PermisoService,
                private sucursalService: SucursalService,
                private sanitizer: DomSanitizationService,
                private router: Router) {
    }

    ngOnInit() {
        window.scrollTo(0, 0);

        //Usuario logueado
        this.usuario = this.loginService.getDecodeToken();

        //Pedir permisos
        this.offsetTimeZone = "-03:00";
        this.urlLogo = "";
        this.permisos = new Map();
        this.permisoService.getPermiso("documento").subscribe(permisos => {
            for (let permiso of permisos.tipoPermiso) {
                this.permisos.set(permiso.descripcion, true);
            }
            //Si no tiene permiso para ver redirijo
            if (!this.permisos.get("read"))
                this.router.navigate(['/home']);
        });

        //Sucursales
        this.sucursalService.getSucursales().subscribe((data) => {
            this.sucursales = data;
        });

        //Inicializar tabla
        var grid = $("#grid-data").on("initialized.rs.jquery.bootgrid", function () {
        }.bind(this)).bootgrid({
            ajax: true,
            selection: true,
            multiSelect: false,
            rowSelect: true,
            formatters: {
                "estado": (column, row) => {
                    return row.estado == true ? (row.usuariosNotificados.indexOf(this.loginService.getDecodeToken().id) === -1 ? "<span class=\"label label-success\">Nuevo</span>" : "Activo") : "<span class=\"label label-danger\">Inactivo</span>"
                },
                "usuarioUltMdf_id": function (column, row) {
                    return row.usuarioUltMdf_id ? row.usuarioUltMdf_id.nombre + " " + row.usuarioUltMdf_id.apellido : "";
                },
                "ext": function (column, row) {
                    let re = /(?:\.([^.]+))?$/;
                    let ext = re.exec(row.filename)[1];
                    return row.filename && ext ? ext : "";
                },
                "sucursal_id": function (column, row) {
                    return row.sucursal_id ? row.sucursal_id.descripcion : "";
                },
                "fechaUltMdf": function (column, row) {
                    var date_str = row.fechaUltMdf;
                    if (moment(date_str).isValid())
                        return moment(date_str).utcOffset(this.offsetTimeZone).format("DD-MM-YYYY HH:mm");
                    else
                        return "";
                }.bind(this),
                "commands": function (column, row) {
                    return "<button type=\"button\" class=\"btn btn-xs btn-default command-edit\" data-row-id=\"" + row._id + "\" " + ((!row.contentType || (!row.contentType.includes('image') && !row.contentType.includes('pdf'))) ? " disabled" : '') + "><span class=\"fa fa-eye\"></span></button> " +
                        "<button type=\"button\" class=\"btn btn-xs btn-default command-delete\" data-row-id=\"" + row._id + "\"><span class=\"fa fa-cloud-download\"></span></button>";
                }
            },
            requestHandler: ((request) => {
                //Add your id property or anything else
                request.sucursal_id = this.sucursal_id;
                return request;
            }),
            responseHandler: function (data) {
                this.documentos = data.rows;
                return data;
            }.bind(this),
            ajaxSettings: {
                headers: {
                    "Authorization": this.loginService.getToken()
                },
                method: "GET"
            },
            url: myGlobals.default.BASE_URL + "/documento/documentosTable",
        }).bind(this).on("loaded.rs.jquery.bootgrid", function () {
            /* Executes after data is loaded and rendered */
            let documentComponent = this;
            grid.find(".command-edit", documentComponent).on("click", function (e) {
                this.previewImagen($(e.currentTarget).attr("data-row-id"));

            }.bind(this)).end().find(".command-delete").on("click", function (e) {
                this.downloadImagen($(e.currentTarget).attr("data-row-id"));
            }.bind(this));
        }.bind(this));

        //Cerrar alert
        $("#alertSeleccion").hide();

        //Inicializar banderas para resetear forms
        this.active = true;
        this.active2 = true;
        //Inicializar documento
        this.documento = new Documento();

        //Inicializar bandera deshabilitar
        this.deshabilitar = true;

        this.usuario = this.loginService.getDecodeToken();
    }

    ngOnDestroy() {
    }

    agregar() {
        //Inicializo variables
        this.documento = new Documento();
        //Seteo bandera para deshabilitar
        this.deshabilitar = false;
        this.urlLogo = "";
        this.filesToUpload = "";
        //Muestro modal
        $("#modalDocumento").modal("show");
        //Cerrar alert
        $("#alertSeleccion").hide();
        setTimeout(() => $("#logo").click(), 300);
    }

    modificar() {
        //Limpio foto
        this.urlLogo = "";
        this.filesToUpload = "";

        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        } else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco documento
                this.documentoService
                    .getDocumento(this.idSeleccionado)
                    .subscribe(documento => {
                        //Cargo datos de la documento
                        this.documento = documento;
                        //Cargo foto
                        var byteArray = new Uint8Array(documento.logo.data.data);
                        var file = new Blob([byteArray], {type: documento.logo.contentType});
                        var reader = new FileReader();
                        reader.onloadend = function () {
                            this.urlLogo = reader.result;
                        }.bind(this);
                        if (file) {
                            reader.readAsDataURL(file);
                        } else {
                            this.urlLogo = "";
                        }
                    });

                //Seteo bandera para deshabilitar
                this.deshabilitar = false;
                //Muestro modal
                $("#modalDocumento").modal("show");
            }
        }
    }

    eliminar() {
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        } else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco documento
                this.documentoService
                    .getDocumento(this.idSeleccionado)
                    .subscribe(documento => {
                        this.documentoService.delete(documento).subscribe(() => $("#grid-data").bootgrid("reload"));
                    });
            }
        }
    }

    ver() {
        //Limpio foto
        this.urlLogo = "";
        this.filesToUpload = "";
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        } else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco documento
                this.documentoService
                    .getDocumento(this.idSeleccionado)
                    .subscribe(documento => {
                        this.documento = documento;
                        if (documento.logo) {
                            var byteArray = new Uint8Array(documento.logo.data.data);
                            var file = new Blob([byteArray], {type: documento.logo.contentType});
                            var reader = new FileReader();
                            reader.onloadend = function () {
                                if (file.type === "application/pdf" || file.type === "application/doc" || file.type === "application/docx")
                                    this.urlLogo = null;
                                else
                                    this.urlLogo = reader.result;
                            }.bind(this);
                            if (file) {
                                reader.readAsDataURL(file);
                            } else {
                                this.urlLogo = "";
                            }
                        }
                        this.documentoService.getDocumentos().subscribe();
                        $("#grid-data").bootgrid("reload");
                    });

                //Seteo bandera para deshabilitar
                this.deshabilitar = true;
                //Muestro modal
                $("#modalDocumento").modal("show");
            }
        }
    }

    save() {
        this.documentoService
            .save(this.documento, this.filesToUpload)
            .subscribe((documento) => {
                this.documento = documento;
                //Inicializo variables
                this.documento = new Documento();
                //this.documento.logo=this.filesToUpload;
                //Ocultar modal
                $("#modalDocumento").modal("hide");
                //Reseteo formDocumento para eliminar errores
                this.active = false;
                setTimeout(() => this.active = true, 0);
                //Recargo tabla
                $("#grid-data").bootgrid("reload");
                this.documentoService.getDocumentos().subscribe();
            })
    }


    hideAlert() {
        $("#alertSeleccion").hide();
    }

    verFoto(input) {
        if (input.files.length > 0) {
            var file = input.files[0];

            var reader = new FileReader();
            reader.onloadend = function () {
                if (file.type === "application/pdf" || file.type === "application/doc" || file.type === "application/docx")
                    this.urlLogo = null;
                else
                    this.urlLogo = this.sanitizer.bypassSecurityTrustUrl(reader.result);
            }.bind(this);

            if (file) {
                reader.readAsDataURL(file);
            } else {
                this.urlLogo = "";
            }
            this.filesToUpload = file;
        }
    }

    getDocumentoById(id) {
        let encontrado = null;
        if (this.documentos)
            this.documentos.forEach(function (documento) {
                if (documento._id == id) {
                    encontrado = documento;
                    return
                }
            }.bind(this));
        return encontrado;
    }

    previewImagen(_id) {
        this.documentoService.getDocumentoFile(_id).subscribe((file) => {
            let documento = this.getDocumentoById(_id);
            if (documento.contentType === "application/pdf") {
                var byteCharacters = atob(encodeURI(file));
                var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                var byteArray = new Uint8Array(byteNumbers);
                var file2 = new Blob([byteArray], { type: 'application/pdf;base64' });
                var fileURL = URL.createObjectURL(file2);
                window.open(fileURL);
                // const linkSource = `data:application/pdf;base64,${file}`;
                // let pdfWindow = window.open("")
                // pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(file) + "'></iframe>")
            } else {
                const linkSource = `data:${documento.contentFile};base64,${file}`;
                document.getElementById('imgPreviewFullscreen').classList.add("visible");
                document.getElementById('divPreviewFullscreen').classList.add("visible");
                (<HTMLImageElement>document.getElementById('imgPreviewFullscreen')).src = linkSource;
                $("body").css("overflow", "hidden");
            }
            this.documentoService.getDocumentos().subscribe();
            $("#grid-data").bootgrid("reload");
        });


    }

    downloadImagen(_id) {
        this.documentoService.getDocumentoFile(_id).subscribe((file) => {
            let documento = this.getDocumentoById(_id);
            const linkSource = `data:${documento.contentFile};base64,${file}`;
            const downloadLink = document.createElement("a");
            const fileName = documento.filename;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
            this.documentoService.getDocumentos().subscribe();
            $("#grid-data").bootgrid("reload");
        });
    }

    cerrarPreviewImagen() {
        document.getElementById('imgPreviewFullscreen').classList.remove("visible");
        document.getElementById('divPreviewFullscreen').classList.remove("visible");
        // eslint-disable-next-line
        // noinspection TypeScriptUnresolvedVariable
        (<HTMLImageElement>document.getElementById('imgPreviewFullscreen')).src = "";
        $("body").css("overflow", "auto");
    }

    onChangeSucursal(e) {
        this.sucursal_id = e.target.value;
        $("#grid-data").bootgrid("reload");
    }


    cerrarModal() {
        //Reseteo formDocumento para eliminar errores
        this.active = false;
        setTimeout(() => this.active = true, 0);
        //Reseteo formContacto para eliminar errores
        setTimeout(() => this.active2 = false, 0);
        setTimeout(() => this.active2 = true, 0);
        this.documento = new Documento();
        $("#modalDocumento").modal("hide");
    }

    synchronizeDrive() {
        this.documentoService.synchronizeDrive().subscribe();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/documento/documento.component.ts